import React from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';
import { Button } from '@oysterjs/ui/button';
import { Dialog, DialogActions, DialogDescription, DialogTitle } from '@oysterjs/ui/dialog';

/** Asks before leaving a template with unsaved changes, unless allowLeaveRef says not to. */
export const DiscardChangesDialog = ({
  hasUnsavedChanges,
  allowLeaveRef
}: {
  hasUnsavedChanges: boolean;
  allowLeaveRef: React.MutableRefObject<boolean>;
}) => {
  const shouldAsk = () => hasUnsavedChanges && !allowLeaveRef.current;
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldAsk() && currentLocation.pathname !== nextLocation.pathname
  );
  useBeforeUnload(
    React.useCallback(
      (event: BeforeUnloadEvent) => {
        if (shouldAsk()) event.preventDefault();
      },
      [hasUnsavedChanges]
    )
  );

  return (
    <Dialog open={blocker.state === 'blocked'} onClose={() => blocker.reset?.()}>
      <DialogTitle>Discard your changes?</DialogTitle>
      <DialogDescription>
        You changed this template but didn't save. If you leave now, your changes will be lost.
      </DialogDescription>
      <DialogActions>
        <Button color="white" onClick={() => blocker.reset?.()}>
          Keep editing
        </Button>
        <Button color="red" onClick={() => blocker.proceed?.()}>
          Discard changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
